export default {
  resName: [
    {
      id: 'introduction',
      label: 'tabs#resName_introduction',
    },
    {
      id: 'description',
      label: 'tabs#resName_description',
    },
  ],
};
